module.exports = __webpack_public_path__ + "static/media/AppIcon.b81eada2.png";